import type { TFunction } from "i18next";
import { z } from "zod";
import { BILLING_TYPES } from "@/types/Form";
import type { Tariff } from "@/types/Operator";

export const getStep3Schema = (t: TFunction) =>
  z
    .object({
      billingType: z.enum(BILLING_TYPES, {
        message: t("step3.validation.billingType"),
      }),
      margin: z.string().optional(),
      fixedFee: z.string().optional(),
      fixedPrice: z.string().optional(),
      tariff: z.custom<Tariff>().optional(),
    })
    .superRefine((data, ctx) => {
      if (data.billingType === "dynamic") {
        if (!data.margin && !data.fixedFee) {
          ctx.addIssue({
            code: "custom",
            path: ["margin"],
            message: t("step3.validation.marginOrFixedFeeRequired"),
          });
        }
      }
      if (data.billingType === "constant" && !data.fixedPrice) {
        ctx.addIssue({
          code: "custom",
          path: ["fixedPrice"],
          message: t("step3.validation.fixedPriceRequired"),
        });
      }
      if (data.billingType === "tariff" && !data.tariff) {
        ctx.addIssue({
          code: "custom",
          path: ["tariff"],
          message: t("step3.validation.tariffRequired"),
        });
      }
    });

export type Step3Schema = z.infer<ReturnType<typeof getStep3Schema>>;

export type Step3FormKeys = keyof Step3Schema;
